import { useState } from 'react';

// Combobox accesible (patrón APG "combobox with listbox popup"), para los typeaheads que hoy son
// mouse-only (opciones con onMouseDown + cierre en blur → imposible elegir con teclado; bloquea
// crear sesiones OPU, transferencias, ventas, partos…). El foco NO se mueve a las opciones: se
// queda en el input y las flechas mueven una "opción activa" vía aria-activedescendant.
//
// Uso:
//   const choose = (item) => { setText(''); onSelect?.(item); };
//   const cb = useCombobox({ items, onChoose: choose });
//   <input role="combobox" aria-autocomplete="list" aria-expanded={cb.open}
//          aria-controls={cb.listId} aria-activedescendant={cb.activeId}
//          onFocus={cb.onFocus} onBlur={cb.onBlur} onKeyDown={cb.onKeyDown}
//          onChange={(e) => { setText(e.target.value); cb.setOpen(true); }} … />
//   {cb.open && (
//     <div role="listbox" id={cb.listId}>
//       {items.map((it, i) => (
//         <button role="option" id={cb.optionId(i)} aria-selected={cb.activeIndex === i}
//                 className={cb.activeIndex === i ? 'search__item search__item--active' : 'search__item'}
//                 onMouseDown={cb.onOptionMouseDown(it)} onMouseEnter={() => cb.setActive(i)}>…</button>
//       ))}
//     </div>
//   )}

let seq = 0;

export function useCombobox({ items = [], onChoose }) {
    const [open, setOpen] = useState(false);
    const [activeIndex, setActiveIndex] = useState(-1);
    const [uid] = useState(() => ++seq); // id de instancia estable (para listId/optionId)

    const listId = `cbx-list-${uid}`;
    const optionId = (i) => `cbx-opt-${uid}-${i}`;
    const count = items.length;
    const active = activeIndex >= 0 && activeIndex < count ? activeIndex : -1;

    const close = () => { setOpen(false); setActiveIndex(-1); };
    const pick = (item) => { onChoose?.(item); close(); };

    const onKeyDown = (e) => {
        if (e.key === 'ArrowDown') { e.preventDefault(); setOpen(true); setActiveIndex((i) => (i + 1 < count ? i + 1 : 0)); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); setOpen(true); setActiveIndex((i) => (i > 0 ? i - 1 : count - 1)); }
        else if (e.key === 'Enter') { if (open && active >= 0) { e.preventDefault(); pick(items[active]); } }
        else if (e.key === 'Escape') { if (open) { e.preventDefault(); e.stopPropagation(); close(); } }
    };

    return {
        open,
        setOpen,
        activeIndex: active,
        setActive: setActiveIndex,
        listId,
        optionId,
        activeId: open && active >= 0 ? optionId(active) : undefined,
        onKeyDown,
        onFocus: () => setOpen(true),
        // El blur cierra la lista; onMouseDown en las opciones hace preventDefault, así que un
        // clic de mouse no dispara este blur antes de elegir.
        onBlur: () => close(),
        onOptionMouseDown: (item) => (e) => { e.preventDefault(); pick(item); },
        close,
    };
}
